/**
 * Renderizador do formulário de 1 step para form-no-cep + LP de Ofertas (isOfferlp === true)
 */

import { escapeHtml } from '../helpers/ofertaFormularioHelpers.js';
import { renderCheckboxes } from './sharedCheckboxes.js';

/**
 * Renderiza o formulário único: Nome, Email, Telefone, checkboxes LGPD, CPF,
 * Estado/Cidade (sempre obrigatórios, cascata IBGE) e Data de Nascimento condicional.
 * Sem indicador de progresso, sem campo CEP, sem perguntas de LP de interesse
 * (isOfferlp é sempre true neste fluxo).
 */
export function renderNoCepOfertaForm(config, ofertaData) {
    const { cssPrefix } = config;

    const hasOptInWidget = ofertaData?.optin_widget || false;
    const textAceite = ofertaData?.aceptText || '';
    const textCiente = ofertaData?.textAware || '';
    const textDeclaro = ofertaData?.textDeclare || '';
    const hasBirthDate = ofertaData?.birthDate === true;

    return `
        <form class="${cssPrefix}-form" id="${cssPrefix}-form-no-cep-oferta" novalidate>
            <h4>${escapeHtml(config.titleForm)}</h4>

            <input type="text" name="name" id="${cssPrefix}-name" placeholder="Nome*" />
            <div id="${cssPrefix}-name-error" class="${cssPrefix}-error"></div>

            <input type="email" name="email" id="${cssPrefix}-email" placeholder="E-mail*" />
            <div id="${cssPrefix}-email-error" class="${cssPrefix}-error"></div>

            <input type="tel" name="phone" id="${cssPrefix}-phone" placeholder="Telefone*" maxlength="15" />
            <div id="${cssPrefix}-phone-error" class="${cssPrefix}-error"></div>

            <input type="text" name="cpf" id="${cssPrefix}-cpf" placeholder="CPF*" maxlength="14" />
            <div id="${cssPrefix}-cpf-error" class="${cssPrefix}-error"></div>

            ${hasBirthDate ? `
                <div class="${cssPrefix}-birthdate-wrapper">
                    <input type="date" name="birthDate" id="${cssPrefix}-birthdate" />
                    <label for="${cssPrefix}-birthdate" class="${cssPrefix}-birthdate-placeholder">Data de nascimento *</label>
                </div>
                <div id="${cssPrefix}-birthdate-error" class="${cssPrefix}-error"></div>
            ` : ''}

            <div class="${cssPrefix}-state-city-row">
                <select name="state" id="${cssPrefix}-state" class="${cssPrefix}-select ${cssPrefix}-select-half">
                    <option value="">Estado*</option>
                </select>
                <select name="city" id="${cssPrefix}-city" class="${cssPrefix}-select" disabled>
                    <option value="">Cidade*</option>
                </select>
            </div>
            <div class="${cssPrefix}-state-city-errors">
                <div id="${cssPrefix}-state-error" class="${cssPrefix}-error ${cssPrefix}-location-error"></div>
                <div id="${cssPrefix}-city-error" class="${cssPrefix}-error ${cssPrefix}-location-error"></div>
            </div>

            <div class="${cssPrefix}-checkbox-group" id="${cssPrefix}-checkboxes">
                ${renderCheckboxes(cssPrefix, hasOptInWidget, textAceite, textCiente, textDeclaro, ofertaData?.optin_widget)}
            </div>

            <p class="${cssPrefix}-required-note">Campos marcados com * são obrigatórios.</p>

            <div class="${cssPrefix}-step-buttons">
                <button type="submit" class="${cssPrefix}-btn-submit" id="${cssPrefix}-btn-submit-no-cep">Finalizar cadastro</button>
            </div>
        </form>
    `;
}
